



















import Vue from 'vue';
import {
  ScheduleDelayUnit,
  ScheduleDelay,
  DelayMode,
} from '../../../models/ScheduleDelay';
import { EventTriggered } from '../../../models/ScheduleRuleContext';
import { ScheduleEventType } from '../../../models/ScheduleEventParam';

const createRange = function(from: number, to: number): Array<number> {
  const r = [];
  for (let i = from; i <= to; i++) {
    r.push(i);
  }
  return r;
};

const hours = createRange(0, 47);
const minutes = [0, 1, 3, 5, 10, 15, 30, 45];

export default Vue.extend({
  data() {
    return {
      hours,
      minutes,
      ScheduleEventType,
      result: {
        minute: null,
        hour: null,
      },
    };
  },
  props: {
    eventTriggered: {
      type: Object as () => EventTriggered,
    },
  },
  mounted() {
    this.$nextTick( () => {
      const delay = this.eventTriggered && this.eventTriggered.delay;
      const fixedMinutes =
        delay &&
        delay.Fixed &&
        delay.Fixed.unit === ScheduleDelayUnit.Minute &&
        delay.Fixed.amount;

      if (fixedMinutes) {
        const hour = Math.trunc(fixedMinutes / 60);
        const minute = fixedMinutes % 60;
        if(hours.indexOf(hour) !== -1 && minutes.indexOf(minute) !== -1) {
          this.result.hour = hour;
          this.result.minute = minute;
        }
      }
    });
  },
  methods: {
    validate(): boolean {
      if (this.result.minute === null) {
        this.$Message.warning('请选择分钟数');
        return false;
      }
      if (this.result.hour === null) {
        this.$Message.warning('请选择小时数');
        return false;
      }
      return true;
    },
    confirm(): void {
      if (this.validate()) {
        const delay: ScheduleDelay = {
          Fixed: {
            amount: this.result.minute + this.result.hour * 60,
            unit: ScheduleDelayUnit.Minute,
          },
        };
        this.$store.commit('UPDATE_SCHEDULE_DELAY', delay);
        this.$store.commit('UPDATE_EVENT_DELAY_MODE', DelayMode.UseMsg);
        this.$emit('close');
      }
    },
  },
});
